import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import TwoFactorTokenExpired from '../TwoFactorTokenExpired';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class TwoFactorRecoveryForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderAdminRecoveryButton = () => {
      const {
        onAdminRecoveryPressed
      } = this.props;
      return /*#__PURE__*/_jsx(Button, {
        block: true,
        "data-test-id": "2fa-get-help-from-admin-button",
        use: "primary",
        type: "submit",
        onClick: onAdminRecoveryPressed,
        children: I18n.text('login.twoFactor.recovery.form.recoveryAdminButton')
      });
    };
    this.renderSupportRecoveryButton = () => {
      const {
        onSupportRecoveryPressed
      } = this.props;
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("a", {
          onClick: onSupportRecoveryPressed,
          children: I18n.text('login.twoFactor.recovery.form.recoverySupportButton')
        })
      });
    };
    this.renderForm = () => {
      return /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.twoFactor.recovery.form.description"
          })
        }), this.renderAdminRecoveryButton(), this.renderSupportRecoveryButton()]
      });
    };
  }
  render() {
    const {
      isTokenExpired
    } = this.props;
    let content;
    if (isTokenExpired) {
      content = /*#__PURE__*/_jsx(TwoFactorTokenExpired, {});
    } else {
      content = this.renderForm();
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          as: "h1",
          children: I18n.text('login.twoFactor.recovery.header')
        })
      }), content]
    });
  }
}
TwoFactorRecoveryForm.propTypes = {
  isTokenExpired: PropTypes.bool.isRequired,
  onAdminRecoveryPressed: PropTypes.func.isRequired,
  onSupportRecoveryPressed: PropTypes.func.isRequired
};